require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./promotion-des-sciences-1-1-5.json") })
        }
      }, "path---promotion-des-sciences-1-1-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---promotion-des-sciences-1-1-5!./.cache/json/promotion-des-sciences-1-1-5.json
// module id = 537
// module chunks = 231608221292675